import { render, staticRenderFns } from "./TextViewer.vue?vue&type=template&id=23b3a1f4&scoped=true&"
import script from "./TextViewer.vue?vue&type=script&lang=ts&"
export * from "./TextViewer.vue?vue&type=script&lang=ts&"
import style0 from "./TextViewer.vue?vue&type=style&index=0&id=23b3a1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3a1f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
